import moment from 'moment';
import { CONTACTS_USERS_PER_TAKE } from '../contactsJourney/Constants';
import { getNodeName } from '../contactsJourney/utils/contactsJourneyUtils';
const SEARCH_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
const JOURNEY_TIMEOUT = 300000;
export var DATA_SOURCE;
(function (DATA_SOURCE) {
    DATA_SOURCE["CASSANDRA"] = "cassandra";
    DATA_SOURCE["SQL"] = "sql";
})(DATA_SOURCE || (DATA_SOURCE = {}));
export class ContactsJourneyService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async getJourneyEdges(searchPeriod, dataSource, firstNode, maxSteps, maxNodesPerStep) {
        const startDate = moment(searchPeriod.startDate).format(SEARCH_DATE_FORMAT);
        const endDate = moment(searchPeriod.endDate).format(SEARCH_DATE_FORMAT);
        const params = {
            startDate: encodeURIComponent(startDate),
            endDate: encodeURIComponent(endDate),
            dataSource,
            timeout: JOURNEY_TIMEOUT,
            firstNode,
            ...(maxSteps !== undefined && { maxSteps }),
            ...(maxNodesPerStep !== undefined && { maxNodesPerStep }),
        };
        const queryString = Object.entries(params)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'get',
            to: 'postmaster@analytics.msging.net',
            uri: `/contacts-journey?${queryString}`,
        }, JOURNEY_TIMEOUT);
        return this.MessagingHubService.ensureCommandSuccess(commandResponse).resource.items;
    }
    async getEdgeContacts(searchPeriod, selectedJourneyEdge, dataSource, firstNode, skip = 0, take = CONTACTS_USERS_PER_TAKE) {
        const startDate = moment(searchPeriod.startDate).format(SEARCH_DATE_FORMAT);
        const endDate = moment(searchPeriod.endDate).format(SEARCH_DATE_FORMAT);
        const { selectedNodeName } = getNodeName(selectedJourneyEdge);
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'get',
            to: 'postmaster@analytics.msging.net',
            uri: `/contacts-journey/${encodeURIComponent(selectedNodeName)}/users?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&skip=${skip}&take=${take}&timeout=${JOURNEY_TIMEOUT}&firstNode=${firstNode}&dataSource=${dataSource}`,
        }, JOURNEY_TIMEOUT);
        return this.MessagingHubService.ensureCommandSuccess(commandResponse).resource.items;
    }
    async getJourneyCSVData(searchPeriod, selectedJourneyEdge, dataSource, firstNode) {
        const startDate = moment(searchPeriod.startDate).format(SEARCH_DATE_FORMAT);
        const endDate = moment(searchPeriod.endDate).format(SEARCH_DATE_FORMAT);
        const { selectedNodeName } = getNodeName(selectedJourneyEdge);
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'get',
            to: 'postmaster@analytics.msging.net',
            uri: `/contacts-journey/${encodeURIComponent(selectedNodeName)}/download-users-csv?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&firstNode=${firstNode}&dataSource=${dataSource}`,
        });
        return this.MessagingHubService.ensureCommandSuccess(commandResponse).resource;
    }
}
ContactsJourneyService.$inject = ['MessagingHubService'];
